// A chave do Círculo no app (20/10/2026): o servidor diz em /api/recursos se o
// Círculo está ligado (CIRCULO_ATIVO, server/circulo/chave.js). Perguntado uma
// vez, ao carregar. Enquanto não responde, ou se falhar, vale DESLIGADO para as
// entradas (Home, aba Eu); as telas do Círculo esperam a resposta.

import { recursos } from '../recursos';

let valor: boolean | null = null;

const promessa: Promise<boolean> = recursos.then((j) => (valor = j.circulo === true));

/** O que já se sabe: true, false ou null (ainda perguntando). */
export const circuloAtivoAgora = (): boolean | null => valor;

/** A resposta do servidor (uma vez por carregamento). */
export const circuloAtivo = (): Promise<boolean> => promessa;
